import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "../../core/translation.core";
import { useQuery } from "@tanstack/react-query";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { selectCss } from "../reuseables/native.comp";
import localeCore from "../../core/locale.core";
import recycleCore from "../../core/recycle.core";
import { ReceiveRecycleFormData } from "../../types/recycle";

interface RecycleProductSelectorProps {
  methods: UseFormReturn<ReceiveRecycleFormData, any>;
}
export default function RecycleProductSelector({ methods }: RecycleProductSelectorProps) {
  const { t, msg } = useTranslation();

  const {
    data: recycleProducts,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ["recycleProducts"],
    queryFn: recycleCore.listRecycleProducts,
  });

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <div id="recycle-products-list" className="w-full">
      <div className="">
        <h2>{t(msg.posMenuItems.selectProduct)}</h2>
        <select className={`${selectCss} w-full max-w-64 text-xs h-[44px]`} {...methods.register("productId")}>
          {recycleProducts!.map((p) => (
            <option key={p.id} value={p.id}>
              {localeCore.getLocaleValueDefault(p.name)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
